<template>
    <div class="template-wrapper">
		<h2 class="page-title">{{ $t('paymentRecords') }}</h2>
		<el-divider></el-divider>
    <template v-if="exportcsv === '1'">
        <!--
      <export-excel
			:data="tableDataExcel"
			:fields = "tableDataExcelFields"
			:name="$t('paymentRecords')+'.xls'"
			class="el-button el-button--default">
			{{ $t('exportPaymentRecords') }}
		</export-excel>-->
        <el-button @click="exporttocsv($t('paymentRecords'))">{{ $t("exportPaymentRecords") }}</el-button>
    </template>

    <template v-if="payment_read === '1'">
      <br />
      <br />
      <!--
      <el-form ref="storeform" :model="storeform">
        <el-form-item :label="$t('selectStore')">
          <template>
            <div class="" style="display: flex">
              <el-select v-model="storeform.storeid" placeholder="" @change="changeTableStoreid">
                <el-option :label="$t('all')" value="" v-if="storeid === null"></el-option>
                <el-option v-for="item in storelist" :label="item.storeid+' ('+item.name+')'" :value="item.storeid"></el-option>
              </el-select>
            </div>
          </template>
        </el-form-item>
      </el-form>
      -->
      <el-collapse>
        <el-collapse-item :title="$t('searchByConditions')" name="1">
          <el-form ref="storeform" :model="storeform">
            <el-form-item :label="$t('selectStore')">
              <template>
                <div class="" style="display: flex">
                  <el-select v-model="storeform.storeid" placeholder="" @change="changeTableStoreid">
                    <el-option :label="$t('all')" value="" v-if="storeid === null"></el-option>
                    <el-option v-for="item in storelist" :label="item.storeid + ' (' + item.name + ')'"
                      :value="item.storeid"></el-option>
                  </el-select>
                </div>
              </template>
            </el-form-item>
          </el-form>
          <div style="margin-bottom: 20px;">
            {{ $t("searchByDate") }}
            <el-date-picker v-model="starttime" type="date" :placeholder="$t('selectDate')">
            </el-date-picker> {{ $t("to") }}
            <el-date-picker v-model="endtime" type="date" :placeholder="$t('selectDate')">
            </el-date-picker>
          </div>
          <div>
            <el-form ref="typeform" :model="typeform">
                <el-form-item :label="$t('type')">
                    <div style="display: flex">
                        <el-select v-model="typeform.type" placeholder="">
                            <el-option :label="$t('all')" value=""></el-option>
                            <el-option v-for="option in typeOptions" :label="$t(option.label)"
                                :value="option.value"></el-option>
                        </el-select>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <el-form ref="paymentform" :model="paymentform">
                <el-form-item :label="$t('paymentMethod')">
                    <div style="display: flex">
                        <el-select v-model="paymentform.type" placeholder="">
                            <el-option :label="$t('all')" value=""></el-option>
                            <el-option v-for="option in paymentOptions" :label="$t(option.label)"
                                :value="option.value"></el-option>
                        </el-select>
                    </div>
                </el-form-item>
            </el-form>
        </div>
          <el-button @click="filter()">{{ $t('search') }}</el-button>
        </el-collapse-item>
      </el-collapse>
      <br />
    </template>
    
    <template v-if="payment_read === '1'">
		<el-table :data="tableData" stripe style="width: 100%" @sort-change="sortChange">
      <el-table-column prop="paymenttime" :label="$t('time')" sortable="custom">
		<template slot-scope="scope">
			<div>{{scope.row.paymenttime}}</div>
		</template>
      </el-table-column>
      <el-table-column prop="storeid" :label="$t('storeid')" sortable="custom" width="">
			</el-table-column>
	  <el-table-column prop="orderid" :label="$t('orderid')" sortable="custom">
        <template slot-scope="scope">
            <div>{{ scope.row.orderid }}</div>
            <div v-if="scope.row.customordersn!== '' && scope.row.customordersn!== null">{{$t('customorderid')}}: {{ scope.row.customordersn }}</div>
            <div v-if="scope.row.paymenttype!== '' && scope.row.paymenttype!== null">{{$t('paymenttype')}}: {{ scope.row.paymenttype }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="orderid" :label="$t('type')" sortable="custom">
      <template slot-scope="scope">
          <div v-if="scope.row.orderid.startsWith('E') === true">WhatsApp EShop</div>
          <div v-if="scope.row.orderid.startsWith('P') === true">POS</div>
      </template>
      </el-table-column>
      <el-table-column prop="total_price" :label="$t('totalAmount')" sortable="custom">
      </el-table-column>
      <el-table-column prop="paymentmethod" :label="$t('paymentMethod')" sortable="custom">
        <template slot-scope="scope">
          <div v-if="scope.row.paymentmethod === 'fps' || scope.row.paymentmethod === 'FPS'">FPS</div>
          <div v-else>{{scope.row.paymentmethod}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="paymentid" :label="$t('paymentid')" sortable="custom">
        <template slot-scope="scope">
          {{scope.row.paymentid}}
        </template>
      </el-table-column>
      <el-table-column prop="status" :label="$t('paymentid')" sortable="custom">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 'paid' || scope.row.status === '支付成功'">支付成功</div>
          <div v-if="scope.row.status === 'refunded' || scope.row.status === '退款成功'">退款成功</div>
        </template>
      </el-table-column>
      <el-table-column prop="operation" :label="$t('adminset')" align="center">
          <template slot-scope="scope">
            <div class="operationVid">
              <div v-if="scope.row.paymentmethod === 'fps' || scope.row.paymentmethod === 'FPS'">
                <el-button @click="showRefund(scope.row)" v-if="payment_edit === '1'">{{ $t('viewRefund') }}</el-button>
              </div>
              <span v-if="payment_edit === '0'">{{ $t("NoPermissions") }}</span>
              </div>
            </template>
      </el-table-column>


    </el-table>
    <div class="pagination flex-center">
        <span class="el-pagination__total">{{ $t('total') }} {{totalRecord}} {{ $t('items') }}</span>
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="prev,pager,next"
          :total="totalRecord"
        ></el-pagination>
      </div>
    </template>
    <template v-if="payment_read === '0'">
        <span>{{ $t("NoPermissions") }}</span>
    </template>


    <!-- refund -->
        <el-dialog :title="$t('viewRefund')" :visible.sync="dialogRefundVisible"
        :width="$store.state.isMobile ? '90%' : '956px'" :before-close="handleRefundClose" class="view-dialog">
            <h4>{{ $t('paymentid') }}: {{ refundPaymentID }}</h4>
            <h4>{{ $t('refundAmount1') }}: {{ refundAmount1 }}</h4>
            <h4>{{ $t('refundAmount4') }}: {{ refundAmount4 }}</h4>
            <h4>{{ $t('refundAmount2') }}: {{ refundAmount2 }}</h4>
            <h4>{{ $t('refundAmount3') }}: {{ refundAmount3 }}</h4>
            <el-form ref="form" :model="refundform" inline>
              <el-form-item>
                <span slot="label">
                  <b>{{ $t("refundApplyAmount") }}:</b>
                </span>
                <el-input v-model="refundform.amount" style="width: 180px;"></el-input>
              </el-form-item>
              
              <el-form-item>
                <el-button type="primary" @click="applyrefund()">{{ $t("refundApply") }}</el-button>
              </el-form-item>
            </el-form>
            <div class="add-template">
                  <el-table :data="refundData.slice((refundDataCurrentPage - 1) * refundDataPageSize, refundDataCurrentPage * refundDataPageSize)
                        " stripe style="width: 100%">
                        <el-table-column prop="created_at" :label="$t('time')" sortable="custom">
                            <template slot-scope="scope">
                                <div>{{ scope.row.created_at }} </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="refund_id" :label="$t('refundid')" sortable="custom" width="200">
                        </el-table-column>
                        <el-table-column prop="refund_amount" :label="$t('refundAmount')" sortable="custom" width="100">
                        </el-table-column>
                        <el-table-column prop="status" :label="$t('status')" sortable="custom" width="100">
                            <template slot-scope="scope">
                                <div v-if="scope.row.status === 'ACTC'">{{ $t('refundStatus1') }}</div>
                                <div v-if="scope.row.status === 'RJCT'">{{ $t('refundStatus2') }}</div>
                                <div v-if="scope.row.status === 'pending'">{{ $t('refundStatus3') }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="refund_txn_ref_id" :label="$t('refundtxnid')" sortable="custom" width="200">
                        </el-table-column>
                        <el-table-column prop="txn_settlement_dt" :label="$t('refundSettlementDate')" sortable="custom">
                        </el-table-column>
                    </el-table>
                    <div class="pagination flex-center">
                        <span class="el-pagination__total">{{ $t("total") }} {{ refundData.length }} {{ $t("items") }}</span>
                        <el-pagination background @current-change="handleRefundDataCurrentChange"
                        :current-page="refundDataCurrentPage" :page-size="refundDataPageSize" layout="prev,pager,next"
                        :total="refundData.length"></el-pagination>
                    </div>
 
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogRefundVisible = false">{{ $t("Cancel") }}</el-button>
                <el-button type="primary" @click="dialogRefundVisible = false">{{
                $t("Sure")
                }}</el-button>
            </span>
        </el-dialog>

    <!-- refund password -->
     <el-dialog :title="$t('refundPassword')" :visible.sync="dialogRefundPasswordVisible"
        :width="$store.state.isMobile ? '90%' : '356px'" :before-close="handleRefundPasswordClose" class="view-dialog">
            <div class="add-template">
              <h4>{{ $t('refundid') }}: {{ refundID }}</h4>
              <h4>{{ $t('refundAmount') }}: {{ refundform.amount }}</h4>
              <br/>
              <el-form ref="form" :model="refundpwform" v-if="refundStatus === false">
                <el-form-item>
                  <span slot="label">
                    <b>{{ $t("refundPassword") }}:</b>
                  </span>
                  <el-input v-model="refundpwform.pw" type="password" show-password></el-input>
                </el-form-item>
              </el-form>
              <template v-if="refundStatus === true">
                  <img style="max-width: 200px;" src="/success.jpeg" />
                  <h2>{{ $t("refundSuccess") }}</h2>
                  <h4>{{ $t("refundtxnid") }}: {{ refundSuccessTxnID }}</h4>
              </template>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogRefundPasswordVisible = false">{{ $t("Cancel") }}</el-button>
                <el-button type="primary" @click="processRefund()">{{
                $t("Sure")
                }}</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
		import { formatDate } from '../../assets/date.js'
		import {getShopOrder, getShopOrder_2, getShopOrder_3, exportShopOrder_2, exportShopOrder_3, getStore,refundDBS} from '@/api'
export default {
    data() {
        return {
          payment_read: '0',
          payment_edit: '0',
          exportcsv: '0',
          show:false,
          currentPage: 1, // 当前页码
          pageSize: 15, // 每页显示的行数
          currentViewPage: 1, // 当前页码
          pageViewSize: 10, // 每页显示的行数
          dialogVisible: false,
          dialogRefundVisible: false,
          dialogRefundPasswordVisible: false,
          tableData: [
          
          ],
          tableDataExcel:[],
          tableDataExcelFields:{
            'payment time': 'paymenttime',
            'store id': 'storeid',
            'order id': 'orderid',
            'custom order id': 'customordersn',
            'payment type': 'paymenttype',
            'type': 'type',
            'name': 'name',
            'whatsapp': 'whatsapp',
            'products': 'products',
            'total amount':'totalprice',
            'payment method':'paymentmethod',
            'payment id':'paymentid'
          },
          viewData: {
            id: "",
            products: []
          },
          viewOrderTitle:"",
          qyid: '',
          storeid: '',
          storelist: [],
          storeform: {
            storeid: ''
          },
          typeOptions: [
				{ label: 'WhatsApp EShop', value: 'whatsapp_eshop' },
                { label: 'POS', value: 'pos' },
			],
            typeform: {
				type: ''
			},
            paymentOptions: [
				{ label: 'FPS', value: 'fps' },
                { label: 'otherPayment', value: 'other' },
			],
            paymentform: {
				type: ''
			},
            refundform: {
                amount: 0
            },
            refundpwform: {
				pw: ''
			},
            starttime: "",
            endtime: "",
            refundData: [],
            refundDataCurrentPage: 1,  // 当前页码
            refundDataPageSize: 10,
            refundAmount1: 0,
            refundAmount2: 0,
            refundAmount3: 0,
            refundAmount4: 0,
            refundPaymentID: '',
            refund_storeid: '',
            refundID: '',
            refundStatus: false,
            refundSuccessTxnID: ''
        }
    },
	filters: {
	  formatDate: function (time) {
	          time = time * 1000     //注意：time应为格式为13位unix時間戳，如果是10位的unix時間戳，需要乘以1000
	                   let date = new Date(time)
	                   return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
	    } 
	  },
	created() {
		var user = JSON.parse(window.localStorage.getItem("userinfo"));
		//console.log(user)
		//this.qyid = user.id 
    var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
		this.qyid = auser.qyid
        this.storeid = auser.storeid
        if(auser.storeid) {
            this.storeform.storeid = auser.storeid
        }
		this.payment_read = auser.payment_read
		this.payment_edit = auser.payment_edit
		this.exportcsv = auser.exportcsv
		this.getlist(auser.storeid);
    this.getstorelist()
	},
    methods: {
		handleCurrentChange(val) {
			this.currentPage = val;
            this.getlist(this.storeform.storeid)
		},
    handleClose() {
      this.dialogVisible = false;
    },
    handleRefundClose() {
			this.dialogRefundVisible = !this.dialogRefundVisible
		},
    handleRefundPasswordClose() {
			this.dialogRefundPasswordVisible = !this.dialogRefundPasswordVisible
		},
    handleRefundDataCurrentChange(val) {
            this.refundDataCurrentPage = val;
        },
    changeTableStoreid() {
				console.log('storeid:' + this.storeform.storeid)
				this.getlist(this.storeform.storeid)
			},
    getstorelist() {
				console.log('go taocan');
				var user = JSON.parse(window.localStorage.getItem('userinfo'))

				let fdata = {
					qyid: this.qyid,
                    storeid: this.storeid
				};
				getStore(fdata).then((res) => {
					if (res.code == 1) {
						console.log(res);
						this.storelist = res.data
					} else {
						this.$message({
							type: "error",
							message: res.msg,
						});
					}
				});
			},
            filter() {
                this.getlist(this.storeform.storeid)
            },
		getlist(storeid) {
		this.show=true
      console.log("go list");
      var user = JSON.parse(window.localStorage.getItem("userinfo"));



      let fdata = {
          //qyid: user.id,
          qyid: this.qyid,
          storeid: storeid,
          //action: "viewpayment"
          starttime: this.starttime,
          endtime: this.endtime,
          type: this.typeform.type,
          payment: this.paymentform.type,
          record_page: this.currentPage,
          record_limit: 15,
          action: "viewpaymentwaeshoppos3"
        };
        console.log("viewpaymentwaeshoppos33333333333333333")
        console.log(this.starttime + ", " + this.endtime)
        getShopOrder_3(fdata).then((res) => {
            if (res.code == 1) {
            console.log(res);
            this.tableData = res.data;
            this.totalRecord = res.total;
            } else {
            this.$message({
                type: "error",
                message: res.msg,
            });
            }
            this.show=false
        });
    },
    viewitem(id) {
        var user = JSON.parse(window.localStorage.getItem("userinfo"));
        let fdata = {
          //qyid: user.id,
          qyid: this.qyid,
          orderid: id,
          action: "view"
        };
        console.log('view: ' + id + " qyid: " + user.id)
        getShopOrder(fdata).then((res) => {
        if (res.code == 1) {
          console.log(res);
          this.viewOrderTitle = this.$t('viewOrders')+ ": " + id;
          this.viewData.id = id;
          this.viewData.products = res.data;
          console.log('res.data')
          console.log(res.data)
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }



        this.dialogVisible = true;
			});
    },
    showRefund(data) {
      this.refundPaymentID = data.paymentid
      this.refund_storeid = data.storeid
            let fdata = {
				qyid: this.qyid,
                storeid: data.storeid,
                payment_id: data.paymentid,
                action: 'refundrecordlist'
			};
            console.log(data)
            console.log('fdata')
            console.log(fdata)
			refundDBS(fdata).then((res) => {
				if (res.code == 1) {
					console.log(res);
					this.refundData = res.all_refund_record
                    this.refundAmount1 = res.success_refund_num
                    this.refundAmount2 = res.success_refund_amount
                    this.refundAmount3 = (data.total_price - res.success_refund_amount).toFixed(2)
                    this.refundAmount4 = data.total_price
					//this.usageRecordAmount4 = res.usedcount_tester
				} else {
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			});
            this.dialogRefundVisible = true
        },
        applyrefund() {
          this.refundID = ''
          this.refundpwform.pw = ''
          this.refundStatus = false
          if(this.refundform.amount <= 0) {
              this.$message({
						type: "error",
						message: '申請退款金額需大過0!',
					});
        }
        else if(this.refundform.amount > this.refundAmount3) {
              this.$message({
						type: "error",
						message: '申請退款金額不可大過可退金額!',
					});

          }
          else {
            let fdata = {
				    qyid: this.qyid,
            storeid: this.refund_storeid,
            payment_id: this.refundPaymentID,
            amount: this.refundAmount4,
            refund_amount: this.refundform.amount,
            action: 'createrefundrequest'
			    };
          console.log(fdata)
          refundDBS(fdata).then((res) => {
				if (res.code == 1) {
					console.log(res);
					this.refundID = res.refund_id
				} else {
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			});
          this.dialogRefundPasswordVisible = true
          }
          
        },
        processRefund() {
          if(this.refundStatus === false){
                let fdata = {
                  qyid: this.qyid,
                  storeid: this.refund_storeid,
                  refund_pw: this.refundpwform.pw,
                  action: 'checkpw'
                }
                refundDBS(fdata).then((res) => {
                if (res.code == 1) {
                  console.log(res);
                  let gdata = {
                    qyid: this.qyid,
                    storeid: this.refund_storeid,
                    refund_id: this.refundID,
                    action: 'processrefund'
                  }
                  console.log(gdata);
                  refundDBS(gdata).then((gres) => {
                    console.log(gres)
                    if (gres.code == 1) {
                      this.refundStatus = true
                      this.refundSuccessTxnID = gres.refund_txn_ref_id

                    } else {
                      this.$message({
                        type: "error",
                        message: gres.status
                      });
                      this.dialogRefundPasswordVisible = false
                    }
                  });

              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            });

          }
          else {
            this.dialogRefundPasswordVisible = false
            this.dialogRefundVisible = false
          }
          

          

          
          

        },
    exporttocsv(name) {
        let fdata = {
            //qyid: user.id,
            qyid: this.qyid,
            storeid: this.storeform.storeid,
            starttime: this.starttime,
            endtime: this.endtime,
            type: this.typeform.type,
            payment: this.paymentform.type,
            action: "viewpaymentwaeshoppos3"
        };
        exportShopOrder_3(fdata).then(res => {
				if (res.code == 1) {
					console.log('getUsersReporttttttttttttttttttt')
					console.log(res)
					//this.tableData = res.data
                    //this.totalRecord = res.total;
					this.tableDataExcel = res.dataExcel
					var csvContent= [
                    Object.keys(this.tableDataExcel[0]).join(","),
                        ...this.tableDataExcel.map(item => Object.values(item).join(","))
                    ]
                        .join("\n")
                        .replace(/(^\[)|(\]$)/gm, "");
                    var link = document.createElement('a');
                    // "\ufeff"是为了解决CSV中文乱码问题
                    var blob = new Blob(["\ufeff" +csvContent],{type: 'text/csv;charset=utf-8;'});
                    var url = URL.createObjectURL(blob);
                    link.href = url;
                    link.setAttribute('download', name + '.csv');
                    link.click();
                    document.body.removeChild(link);
                        } else {
                            console.log('eeeeeeeeeeeeeeeeeeeeee')
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })

		},
    sortChange({ prop, order }) {
      this.tableData.sort(this.compare(prop,order));
    },
    compare (propertyName, sort) {
      return function (obj1, obj2) {
        var value1 = obj1[propertyName]
        var value2 = obj2[propertyName]
        if (typeof value1 === 'string' && typeof value2 === 'string') {
          const res = value1.localeCompare(value2, 'zh')
          return sort === 'ascending' ? res : -res
        } else {
          if (value1 <= value2) {
            return sort === 'ascending' ? -1 : 1
          } else if (value1 > value2) {
            return sort === 'ascending' ? 1 : -1
          }
        }
      }
    }
    }
}
</script>
<style lang="scss" scoped>
.el-pagination__total {
	display: inline-block;
	font-size: 13px;
	min-width: 35.5px;
	height: 28px;
	line-height: 28px;
	vertical-align: top;
	box-sizing: border-box;
}
.pendingList-wrapper {
}
.pagination {
width: 100%;
margin: 30px auto;
}
.centered-content {
  text-align: center; /* Center text content */
}
::v-deep .el-select {
width: 100%;
}
</style>